import { Injectable } from '@angular/core';
import {Platform} from "@ionic/angular";
import {HttpClient, HttpEvent, HttpHeaders} from "@angular/common/http";
import {ApiResult} from "./models/ApiResult";
import {AuthenticationService} from "./authentication.service";
import {AppPlatform} from "./models/app-platform";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class HttpHelperService {
  clientUid: string = '8CC92B47-CFD9-4082-BA75-C6C11082D305';
  platforms: string = '';
  apiVersion = 'v1.1';
  versionNumber = 'web.2.1.6';
  currEnv: Environment = Environment.production;
  // servicePath = 'https://10.211.55.3:5001';
  // servicePath = 'https://localhost:5001';
  // servicePath = 'https://demo-sv-01.starteremponagrody.pl';
  // servicePath = 'https://starteremponagrody.pl';
  get servicePath(): string {
    return this.currEnv === Environment.production ? environment.apiUrl : "https://demo-sv-01.starteremponagrody.pl";
  }
  get apiPath(): string {
    return `${this.servicePath}/api/${this.apiVersion}`;
  }
  isVersionValid!: boolean;
  appPlatform!: AppPlatform;

  public get httpOptions() : Object {
    const result = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
        ClientUid: this.clientUid,
        Platforms: this.platforms,
        Version: this.versionNumber
      })
    };
    return result;
  }
  constructor(private platform: Platform, private http: HttpClient, private authSrv: AuthenticationService) {
    console.log('environment: ' + environment.apiUrl);
  }
  handleLogout() {

  }
  public get<T>(url: string) {
    // if (this.platform.is('desktop') || this.platform.is('mobileweb')) { }
    return new Promise<T>((resolve, reject) => {
      const url_combined = `${this.apiPath}/${url}`;
      this.http.get<T>(`${this.apiPath}/${url}`, this.httpOptions).subscribe({
        next: (v: any) => {
          if (v.statusId === 401) {
            this.authSrv.logout();
          }
          resolve(v);
        },
        error: (e) => {
          if (e.status === 401) {
            this.authSrv.logout();
          }
          reject(new ApiResult(e));
        }
      });
    });
  }
  public post<T>(url: string, body: any) : Promise<T> {
    return new Promise<T>((resolve, reject) => {
      this.http.post<T>(`${this.apiPath}/${url}`, body, this.httpOptions).subscribe({
        next: (v:any) => {
          if (v.statusId === 401) {
            this.authSrv.logout();
          }
          resolve(v)
        },
        error: (e) => {
          if (e.status === 401) {
            this.authSrv.logout();
          }
          //console.log('rejecting POST: ' + url);
          reject(new ApiResult(e));
        }
      });
    });
  }
  public put<T>(url: string, body: any) {
    // if (this.platform.is('desktop') || this.platform.is('mobileweb')) { }
    return new Promise<T>((resolve, reject) => {
      this.http.put<T>(`${this.apiPath}/${url}`, body, this.httpOptions).subscribe({
        next: (v:any) => {
          if (v.statusId === 401) {
            this.authSrv.logout();
          }
          resolve(v)
        },
        error: (e) => {
          if (e.status === 401) {
            this.authSrv.logout();
          }
          //console.log('rejecting PUT: ' + url);
          reject(new ApiResult(e));
        }
      });
    });
  }
  public delete<T>(url: string) {
    // if (this.platform.is('desktop') || this.platform.is('mobileweb')) { }
    return new Promise<T>((resolve, reject) => {
      this.http.delete<T>(`${this.apiPath}/${url}`, this.httpOptions).subscribe({
        next: (v:any) => {
          if (v != null && v.statusId != null && v.statusId === 401) {
            this.authSrv.logout();
          }
          resolve(v)
        },
        error: (e) => {
          if (e != null && e.status === 401) {
            this.authSrv.logout();
          }
          //console.log('rejecting DELETE: ' + url);
          reject(new ApiResult(e));
        }
      });
    });
  }
}
export enum Environment {
  staging = 0,
  production = 1
}
